var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.environment)?_c('div',[_c('AppChip',{staticClass:"app-text--no-select",attrs:{"color":_vm.environment.color,"value":_vm.environment.name,"small":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }